(function(jQuery) {

  function _insertValidationHTML(element, msg) {
    var formComponent = jQuery(element).closest('.form-component');
    if (formComponent.length) {
      var input = jQuery(element);
      formComponent.find(input).attr('data-toggle', 'tooltip');
      formComponent.find(input).attr('data-placement', 'bottom');
      formComponent.find(input).attr('title', msg);
      var validationHTML = "<span class='validation-message' ></span>";
      formComponent.append(validationHTML);
      formComponent.find(input).tooltip({
        template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        animation: true
      });
      formComponent.find(input).tooltip('enable');
    }
  }

  function _open(elem, msg) {

    input = jQuery(elem);
    input.closest('.form').addClass('error');
    input.closest('.form-component').addClass('has-error');
    input.attr('title', msg);
    input.closest('.form-component').find('.validation-message').addClass('visible');
    input.closest('.form').find('.fg-arv_go-component button').prop("disabled", true);
    input.next().css('display', 'none');
    input.attr('data-toggle', 'tooltip');
    if (jQuery.isFunction(input.autocomplete)) {
      input.autocomplete('hide');
      input.autocomplete('show');
    }

    //elem.focus();
  }

  function _close(elem) {

    input = jQuery(elem);
    input.closest('.form-component').removeClass('has-error');
    input.closest('.form-component').find('.validation-message').removeClass('visible');
    input.next().css('display', 'block');
    input.tooltip('disable');
    elem.hasFGValidation = false;

    if (jQuery(input.parent()).hasClass('from-component')) {
      input.attr('title', 'Departure location');
    } else {
      input.attr('title', 'Arrival location');
    }

    if (input.closest('.form').find('.has-error').length < 1) {
      input.closest('.form').removeClass('error');
      input.closest('.form').find('.fg-arv_go-component button').prop("disabled", false);
    }


    if (jQuery.isFunction(input.autocomplete)) {
      input.autocomplete('hide');
      input.autocomplete('show');
    }
  }


  jQuery.fn.openFGValidation = function(msg) {

    return this.each(function(msg) {
      if (!this.hasFGValidation) {
        if (!msg) {
          var msg = 'Oops! We can not find this. Please try again.';
        }
        _insertValidationHTML(this, msg);
        this.hasFGValidation = true;
      }
      _open(this, msg);

    }, [msg]);
  };

  jQuery.fn.closeFGValidation = function() {

    return this.each(function() {
      if (this.hasFGValidation) {
        _close(this);
      }

    });

  };

}(jQuery));

define("fg-arv/libs/fgValidation", function(){});

